export default __webpack_public_path__ + "f6ac404b3cec2e18d009dd6c3ac1c83a.svg";